import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'

// Material UI
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import { withStyles, withTheme } from '@material-ui/core/styles'

// Resources
import { Button, Box, IconButton, Snackbar, TableContainer, TablePagination, TextField, Dialog,DialogActions, DialogTitle, List, ListItem, DialogContent } from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import CloseIcon from '@material-ui/icons/Close'
import Visibility from '@material-ui/icons/Visibility'
import { requestUsersByOfficeId, requestEditUsersByEmail,requestAccountsUsersByEmail,requestDeleteUserByEmail } from '../actions/actions'
import Utils from '../resources/Utils'
import CircleLoading from './CircleLoading'
import { CSVLink } from 'react-csv'
import { Height } from '@material-ui/icons'

const styles = theme => ({
  headerTable: {
    fontWeight: 700,
    width: '100%',
    Height: '100px'
  },

  smallCell: {
    margin: 0,
    padding: 0
  },
  tableHeader: {
    position: 'sticky',
    top: '0',
  },
  paginationEnd: {
    position: 'sticky',
    bottom: '0',
    with: '100%'
  },
  activeScroll: {
    overflow: 'auto'
  },
  buttonStyle: {
    minWidth: '100px',
    width: '100%',
    height: window.innerHeight * 0.04,
    position: 'static'
  },
  column: {
    float: "left",
    with: "100%"
  },
  row: {
    content: "",
    display: "table",
    clear: "both"
  }

})
let data = {
  pageNumber: 1,
  pageSize: 5,
  searchByReference: 'default',
  initialDate: '',
  finalDate: ''
}
class UsersTable extends PureComponent {

  constructor(props) {
    super(props)
    this.props.requestUsersByOfficeId(data)
    this.state = {
      notIsData: false,
      isloading: false,
      page: 0,
      rowsPerPage: !Utils.isEmpty(this.props.init.users) && this.props.init.users.status !== 'WARNING' ? this.props.init.users.data.pageSize : 5,
      totalPages: !Utils.isEmpty(this.props.init.users) && this.props.init.users.status !== 'WARNING' ? this.props.init.users.data.totalPage : 0,
      data: !Utils.isEmpty(this.props.init.users) && this.props.init.users.status !== 'WARNING' ? this.props.init.users.data.data : [],
      backgroundColor: this.props.init.config.data.appBarColor,
      height: window.innerHeight - 400,
      snackbar: false,
      snackbarDelete:false,
      snackbarDeleteError:false,
      openDialog:false,
      openDialogDeleteUser:false,
      emailDialog:'',
      notIsDialogData:false,
      accountsData:[],
      initialDate: '',
      finalDate: '',
      email:'',
      deleteUser:''
    }

  }
  handleChangePage = (event, newPage) => {
    this.setState({ isloading: true })
    data.pageNumber = newPage + 1
    data.pageSize = this.state.rowsPerPage
    this.props.requestUsersByOfficeId(data)
    this.setState({
      page: newPage,
      totalPages: this.state.totalPages,
      data: this.state.data
    });
  };
  useTimer() {
    this.setState({ snackbar: true })
    const intervalId = setTimeout(() => {
      this.setState({ snackbar: false })
    }, 5000);
    return () => clearInterval(intervalId); // Clear interval on component teardown
  }
  useTimerDeleteUser() {
    this.setState({ snackbarDelete: true })
    const intervalId = setTimeout(() => {
      this.setState({ snackbarDelete: false })
    }, 5000);
    return () => clearInterval(intervalId); // Clear interval on component teardown
  }
  useTimerDeleteUserError() {
    this.setState({ snackbarDeleteError: true })
    const intervalId = setTimeout(() => {
      this.setState({ snackbarDeleteError: false })
    }, 5000);
    return () => clearInterval(intervalId); // Clear interval on component teardown
  }
  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.init.errorEditStatusUser !== prevProps.init.errorEditStatusUser) {
      if (!Utils.isEmpty(this.props.init.errorEditStatusUser)) {
        if (this.props.init.errorEditStatusUser.status === "ERROR") {
          this.useTimer()
          this.props.init.errorEditStatusUser = ''
        }
      }
    }
    if(this.props.init.deleteUser!==prevProps.init.deleteUser){
      if(!Utils.isEmpty(this.props.init.deleteUser)){
        if(this.props.init.deleteUser.status=='OK'){
          this.useTimerDeleteUser()
          this.props.requestUsersByOfficeId(data)
        }
        if(this.props.init.deleteUser.status=='ERROR'){
          this.useTimerDeleteUserError()
        }
      }
    }
    if (this.props.init.users !== prevProps.init.users) {
      if (this.props.init.users.status === 'WARNING') {
        this.setState({ notIsData: true, page: 0,isloading:false })
      } else {
        const { page, rowsPerPage } = this.state;
        const totalPages = this.props.init.users.data.totalPage;
        const data = this.props.init.users.data.data;
        var numPage = page;
        if ((rowsPerPage * page) > totalPages) {
          numPage = Math.round(totalPages / rowsPerPage)
        }
        this.setState({
          notIsData: false,
          isloading: false,
          page: numPage,
          rowsPerPage: rowsPerPage,
          totalPages: totalPages,
          data: data
        })


      }
      
    } 
      if (this.props.init.accountsUsers !== prevProps.init.accountsUsers) {
        if(!Utils.isEmpty(this.props.init.accountsUsers)){
          this.setState({
            accountsData: this.props.init.accountsUsers.accounts
          })
         }else{
          this.setState({
            accountsData: [],
          })
         }
      }  
  }
  handleChangeRowsPerPage = (event) => {
    this.setState({ isloading: true })
    if ((parseInt(event.target.value, 10) * this.state.page) >= this.state.totalPages) {
      for (let i = this.state.page; i >= 0; i--) {
        if ((parseInt(event.target.value, 10) * i) < this.state.totalPages) {
          data.pageNumber = i + 1
          i = 0
        }

      }
    }
    data.pageSize = parseInt(event.target.value, 10)
    this.props.requestUsersByOfficeId(data)
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: this.state.page > 1 ? data.pageNumber - 1 : this.state.page,
      totalPages: this.state.totalPages,
      data: this.state.data
    });

  };
  handleChangeSearchUser = (event) => {
    if (!(Utils.isEmpty(event.target.value) || event.target.value === '')) {
      this.setState({ isloading: true })
      data.searchByReference = event.target.value
      this.props.requestUsersByOfficeId(data)
      this.setState({
        isloading: false,
        page: 0,
        email:event.target.value,
        rowsPerPage: !Utils.isEmpty(this.props.init.users) && this.props.init.users.status !== 'WARNING' ? this.props.init.users.data.pageSize : 5,
        totalPages: !Utils.isEmpty(this.props.init.users) && this.props.init.users.status !== 'WARNING' ? this.props.init.users.data.totalPage : 0,
        data: !Utils.isEmpty(this.props.init.users) && this.props.init.users.status !== 'WARNING' ? this.props.init.users.data.data : []
      });
    } else {
      data.searchByReference = 'default'
      this.setState({
        email:''
      })
      this.props.requestUsersByOfficeId(data)
    }
  }
  handleUpdateStatusUser = (email, status) => {
    let data = {
      email: email,
      status: status
    }
    this.setState({
      snackbar: false
    })
    this.props.requestEditUsersByEmail(data)
  }
  handleCloseSnackbar = () => {
    this.setState({
      snackbar: false,
      snackbarDelete:false
    })
  }
  handleChangeinitialDate = (event) => {
    this.setState({ isloading: true, initialDate: event.target.value })
    data.initialDate = event.target.value;
    if (!Utils.isEmpty(data.initialDate) && !Utils.isEmpty(data.finalDate)) {
      this.props.requestUsersByOfficeId(data)
    }
  }
  handleChangefinalDate = (event) => {
    this.setState({ isloading: true, finalDate: event.target.value })
    data.finalDate = event.target.value;
    if (!Utils.isEmpty(data.initialDate) && !Utils.isEmpty(data.finalDate)) {
      this.props.requestUsersByOfficeId(data)
    }
  }
  handleTexfieldsClear = () => {
    this.setState({
      initialDate: '',
      finalDate: '',
      email:''
    })
    data.searchByReference = 'default'
    data.initialDate = ''
    data.finalDate = ''
    this.props.requestUsersByOfficeId(data)
  }
  handleShowAccountsByUser=(email)=>{
    this.setState({
      openDialog:true,
      accountsData:[],
      emailDialog:email
    })
    let data = {
      email: email
    };
    this.props.requestAccountsUsersByEmail(data);
  }
  handleShowUserToDelete=(email)=>{
    this.setState({
      openDialogDeleteUser:true,
      emailDialog:email
    })
  }
  renderTableData = () => {
    const { data, page, rowsPerPage,openDialog,emailDialog,openDialogDeleteUser} = this.state;
    const { classes } = this.props
    const slicedData = data.slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage);
    return (
      <TableBody>
        {(!Utils.isEmpty(slicedData)) ?
          slicedData.map((user, idx) => {
            return (
              <TableRow key={idx} >
                <TableCell><Button title={Utils.getMessages().usersMessages.showAccounts} onClick={(e)=>this.handleShowAccountsByUser(user.email)}><Visibility/>&nbsp;<Typography variant="body2" className={classes.smallCell}>{user.email}</Typography></Button></TableCell>
                <TableCell>{(user.status == 1) ? <Typography variant="body2" color="secondary" className={classes.smallCell}>{Utils.getMessages().usersMessages.active}</Typography> : <Typography variant="body2" color='primary' className={classes.smallCell}>{Utils.getMessages().usersMessages.notActive}</Typography>}</TableCell>
                <TableCell><Typography variant="body2" className={classes.smallCell}>{user.registerDate}</Typography></TableCell>
                <TableCell><Typography variant="body2" className={classes.smallCell}>{user.ultimatedlogin}</Typography></TableCell>
                <TableCell><Typography variant="body2" className={classes.smallCell}>
                  {(user.status == 1) ?
                    <Button className={classes.buttonStyle} variant="contained" color="primary" onClick={(e) => this.handleUpdateStatusUser(user.email, 2)} >{Utils.getMessages().usersMessages.buttonBaja}</Button>
                    :
                    <Button className={classes.buttonStyle} variant="contained" color="secondary" onClick={(e) => this.handleUpdateStatusUser(user.email, 1)} >{Utils.getMessages().usersMessages.buttonAlta}</Button>
                  }
                </Typography></TableCell>
                <TableCell>
                  <Button className={classes.buttonStyle} variant="contained" color="primary" onClick={(e)=>this.handleShowUserToDelete(user.email)} >{Utils.getMessages().usersMessages.deleteUser}</Button>
                </TableCell>
              </TableRow>
            )
          }) : ''
        }
        {openDialog?this.renderDialogAccounts(emailDialog):null}
        {openDialogDeleteUser?this.renderDialogDeleteUser(emailDialog):null}

      </TableBody>
    );
  }
  handleCloseDialog=()=>{
    this.setState({
      openDialog:false
    })
  }
  handleCloseDialogDeleteUser=()=>{
    this.setState({
      openDialogDeleteUser:false,
      emailDialog:''
    })
  }
  handleDeleteUser(email){
    this.setState({
      openDialogDeleteUser:false
    })
    let data={
      email:email
    };
    this.props.requestDeleteUserByEmail(data);
  }
  renderDialogDeleteUser=(email)=>{
    const { classes } = this.props
    const {openDialogDeleteUser}=this.state
    return(
      <Dialog open={openDialogDeleteUser}   onClose={this.handleCloseDialogDeleteUser}>
        <DialogTitle>{Utils.getMessages().usersMessages.alert}</DialogTitle>
        <DialogContent style={{textAlign:'center'}}>
        <Typography>{Utils.getMessages().usersMessages.descriptionAlertDelete1} <h4>{email}</h4> {Utils.getMessages().usersMessages.descriptionAlertDelete2} (<b>{Utils.getMessages().usersMessages.accept}</b>)
        </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={this.handleCloseDialogDeleteUser} color="primary">
          {Utils.getMessages().usersMessages.cancel}
          </Button>
          <Button onClick={(e)=>this.handleDeleteUser(email)} color="primary">
            {Utils.getMessages().usersMessages.accept}
          </Button>
        </DialogActions>
      </Dialog>            

    );
  }
  renderDialogAccounts=(email)=>{
    const { classes } = this.props
    const {openDialog, accountsData}=this.state
    return(
      <Dialog open={openDialog}   onClose={this.handleCloseDialog}>
        <Table size='small' >
          <TableCell>        
            <Typography><h4>{email}</h4></Typography>  
          </TableCell>
          <TableCell>
            <IconButton onClick={this.handleCloseDialog}><CloseIcon/></IconButton>
          </TableCell>
        </Table>
        <div style={{minWidth:'200px',textAlign:'center'}}>
        <Typography><h4>{Utils.getMessages().logsUsersPaymentsHeaders.accountNumber}</h4>
        </Typography>
        </div>
        
        {accountsData.length>0?
        <div style={{height:'180px', overflowX:'auto'}}>
          <List>
          {accountsData.map((account,idx)=>(
            <div key={idx} style={{height:'30px',textAlign:'center'}}>
            <Typography>                          
            {account.accountNumber}            
            </Typography>
            </div>

          ))}
          </List>
        </div>
        :
        <div>
        <Typography variant='body1' className={classes.smallCell} style={{ textAlign: 'center' }}>{Utils.getMessages().paymentsMessages.notData}</Typography>
        </div>
        }
        
      </Dialog>            

    );
  }
renderSnackbar(mensaje,snackbar){
  return(
    <div>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar} message={<span>{mensaje}</span>}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleCloseSnackbar}
              >
                <CloseIcon />
              </IconButton>
            ]}
          ></Snackbar>

        </div>
  );
}
  render() {
    const { classes } = this.props
    const { page, rowsPerPage, totalPages, backgroundColor, height, isloading, notIsData, snackbar,snackbarDelete,snackbarDeleteError, initialDate, finalDate,email,data,emailDialog } = this.state;
    const date = new Date();
    return (
      <div>
        {(snackbar) ? this.renderSnackbar(Utils.getMessages().usersMessages.errorUpdate,snackbar) : ''}
        {(snackbarDelete) ? this.renderSnackbar(Utils.getMessages().usersMessages.deleteUserOk,snackbarDelete) : ''}
        {(snackbarDeleteError) ? this.renderSnackbar(Utils.getMessages().usersMessages.deleteUserError,snackbarDeleteError) : ''}

        <div>
          <TableHead>
            {
              window.innerWidth>725?
              <TableRow>
              <TableCell>
                <TextField fullWidth style={{minWidth:'70px'}} type="email" value={email} InputLabelProps={{ shrink: true }}  defi id="standard-basic" label={Utils.getMessages().usersHeaders.email} onChange={this.handleChangeSearchUser} />
              </TableCell>
              <TableCell>
                <TextField fullWidth type="date" value={initialDate}  InputLabelProps={{ shrink: true }} inputProps={{ max: date.toISOString().substring(0, 10) }} defi id="standard-basic" label={Utils.getMessages().paymentsMessages.initialDate} onChange={this.handleChangeinitialDate} />
              </TableCell>
              <TableCell>
                <TextField fullWidth type="date" value={finalDate}  InputLabelProps={{ shrink: true }} inputProps={{ max: date.toISOString().substring(0, 10) }} defi id="standard-basic" label={Utils.getMessages().paymentsMessages.finalDate} onChange={this.handleChangefinalDate} />
              </TableCell>
              <TableCell>
              <Button variant="contained" color="primary" style={{ width: '100%', height: window.innerHeight * 0.04 }} onClick={this.handleTexfieldsClear} >{Utils.getMessages().paymentsMessages.buttonClear}</Button>
              </TableCell>
              <TableCell>
              <CSVLink data={data} filename={Utils.getMessages().usersMessages.title}>
                  <Button variant="contained" color="primary" style={{ width: '100%', height: window.innerHeight * 0.04 }}>
                    {Utils.getMessages().General.exportCSV}
                  </Button>
                </CSVLink>
              </TableCell>
            </TableRow>:<div>
              <TextField fullWidth type="email" InputLabelProps={{ shrink: true, }}  defi id="standard-basic" label={Utils.getMessages().usersHeaders.email} onChange={this.handleChangeSearchUser} /> 
              <TextField fullWidth type="date" value={initialDate}  InputLabelProps={{ shrink: true }} inputProps={{ max: date.toISOString().substring(0, 10) }} defi id="standard-basic" label={Utils.getMessages().paymentsMessages.initialDate} onChange={this.handleChangeinitialDate} />
              <TextField fullWidth type="date" value={finalDate}  InputLabelProps={{ shrink: true }} inputProps={{ max: date.toISOString().substring(0, 10) }} defi id="standard-basic" label={Utils.getMessages().paymentsMessages.finalDate} onChange={this.handleChangefinalDate} /><br/><br/>
              <Button variant="contained" color="primary" style={{ width: '100%', height: window.innerHeight * 0.04 }} onClick={this.handleTexfieldsClear} >{Utils.getMessages().paymentsMessages.buttonClear}</Button><br/><br/>
              <CSVLink data={data} filename={Utils.getMessages().usersMessages.title}>
                  <Button variant="contained" color="primary" style={{ width: '100%', height: window.innerHeight * 0.04 }}>
                    {Utils.getMessages().General.exportCSV}
                  </Button>
                </CSVLink>         
            </div>
            } 
          </TableHead>
        </div>
        <br /><br />
        {
          (isloading) ? <CircleLoading mensajeCargando="Cargando datos" />
            : (notIsData) ?
              <Typography variant='body1' className={classes.smallCell} style={{ textAlign: 'center' }}>{Utils.getMessages().paymentsMessages.notData}</Typography>
              :
              <TableContainer>
                <div className={classes.activeScroll} style={{ 'height': height < window.innerHeight - 400 ? height : (window.innerHeight - 400)}}>
                  <Table>
                    <TableHead className={classes.tableHeader} style={{ background: backgroundColor }}>
                      <TableRow>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().usersHeaders.email}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().usersHeaders.status}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().usersHeaders.regsiterDate}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().usersHeaders.lastSession}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}></Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}></Typography></TableCell>
                      </TableRow>
                    </TableHead>

                    {
                      this.renderTableData()  
                    }
                                      
                  </Table>
                  {(!Utils.isEmpty(this.props.init.users)) ?
                    <TablePagination
                      className={classes.paginationEnd}
                      style={{ 'background': backgroundColor }}
                      labelRowsPerPage={<Typography variant="body1">{Utils.getMessages().pagination.rowsPerPages}</Typography>}
                      labelDisplayedRows={({ from, to, count }) => <Typography variant="body1">{from} - {to} {Utils.getMessages().pagination.of} {count} {Utils.getMessages().pagination.rows}</Typography>}
                      rowsPerPageOptions={[5, 10, 25, 50, 100]}
                      component="div"
                      rowsPerPage={rowsPerPage}
                      backIconButtonText={Utils.getMessages().pagination.previousPage}
                      nextIconButtonText={Utils.getMessages().pagination.nextPage}
                      count={totalPages}
                      page={page}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    /> : ''
                  }
                </div>
              </TableContainer>}
      </div>
    )
  }
}

const mapStateToProps = state => ({ ...state })

const mapDispatchToProps = dispatch => {
  return {
    requestUsersByOfficeId: (data) => {
      dispatch(requestUsersByOfficeId(data))
    },
    requestEditUsersByEmail: (data) => {
      dispatch(requestEditUsersByEmail(data))
    },
    requestAccountsUsersByEmail: (data) => {
      dispatch(requestAccountsUsersByEmail(data))
    },
    requestDeleteUserByEmail: (data) => {
      dispatch(requestDeleteUserByEmail(data))
    },
  }
}

export default compose(
  withRouter,
  withTheme,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(UsersTable)
